import styled from "styled-components";
import { grey } from "@ant-design/colors";

// Define props interface for ResultItem
interface ResultItemProps {
  active?: boolean;
}

const DropDownContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;

  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: 0 2px 8px ${grey[0]};
  overflow: hidden;
  z-index: 5;
`;

const ResultItem = styled.div<ResultItemProps>`
  cursor: pointer;
  padding: 10px 0.7rem;
  background: #fff;
  ${(props) => props.active && `background: ${grey[0]};`}
`;

const Container = styled.div`
  position: relative;
`;

export { DropDownContainer, ResultItem, Container };
